import React from 'react';
import { NutrientStyle } from '../meal.styles';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdDeleteOutline } from 'react-icons/md';

const Nutrients = ({ value, setFieldValue }) => {
  // console.log(value.nutrients)
  const addNutrient = () => {
    setFieldValue('nutrients', [...value.nutrients, { name: '', value: '' }]);
  };

  const removeNutrient = (idx) => {
    const updatedData = value.nutrients.filter((_, i) => i !== idx);
    setFieldValue('nutrients', updatedData);
  };

  const updateNutrient = (idx, field, val) => {
    const updated = [...value.nutrients];
    updated[idx] = { ...updated[idx], [field]: val };
    setFieldValue('nutrients', updated);
  };

  return (
    <NutrientStyle>
      <>
        {value.nutrients &&
          value.nutrients.map((item, idx) => (
            <div
              key={idx}
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '20px'
              }}
            >
              <input
                type="text"
                placeholder="Fat"
                value={value?.nutrients[idx]?.name}
                className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
                onChange={(e) => {
                  updateNutrient(idx, 'name', e.target.value);
                }}
              />
              <div className="inner">
                <input
                  type="text"
                  placeholder="10"
                  className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9.]/g, '');
                    updateNutrient(idx, 'value', Number(numericValue));
                  }}
                />
                <div className="aside">
                  {value.nutrients.length >= 2 && (
                    <div onClick={() => removeNutrient(idx)}>
                      <MdDeleteOutline size={20} className="text-red-500" />
                    </div>
                  )}

                  <div onClick={addNutrient}>
                    <IoMdAddCircleOutline size={20} color="#549a9a" />
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    </NutrientStyle>
  );
};

export default Nutrients;
